import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class ExerciseCardAPI extends BaseAPI {}

export default new ExerciseCardAPI('v1/exercise-card', 'ExerciseCard')
